import { axiosInstance } from '~/services';

import type {
  TypeGetOwnerSupplierBusinessNumberCheckParams,
  TypeGetOwnerSupplierBusinessNumberCheckResponse,
} from '~/types/vender.types';

/**
 * [화주사정보관리 > 공급사관리] 공급사 사업자번호 유효성 체크 조회
 */
const useGetOwnerSupplierBusinessNumberCheck = () => {
  const endPoint = '/api-owner/owner-supplier';

  const getOwnerSupplierBusinessNumberCheck = async ({
    businessNumber,
  }: TypeGetOwnerSupplierBusinessNumberCheckParams) => {
    return axiosInstance
      .get<TypeGetOwnerSupplierBusinessNumberCheckResponse>(`${endPoint}/${businessNumber}/check`)
      .then(({ data }) => {
        return data.data;
      })
      .catch((error) => {
        throw error;
      });
  };

  return { getOwnerSupplierBusinessNumberCheck };
};

export default useGetOwnerSupplierBusinessNumberCheck;
